"use strict";

const mix = require('../lib/mix');
const BasicLegend = require('../lib/legend');
const BasicChart = require('./basic');
const _ = require('lodash');

class LayeredLegend extends BasicLegend {
	constructor(options) {
		super(Object.assign({lineHeight: 16, layers: []}, options));
		_.bindAll(this, 'setValue', 'layerClass', 'layerText');
	}

	get layers() {
		return this.options.layers;
	}

	layerIndex(layer) {
		return this.layers.indexOf(layer);
	}

	layerColourIndex(layer, options) {
		return (this.layerIndex(layer, options) % 15) + 1;
	}

	layerClass(d, i) {
		let colourIndex = this.layerColourIndex(d.layer);
		return `cm-value zl-cc-fill-${colourIndex}`;
	}

	layerText(d, i) {
		let value = this.valueGetter(d, i);
		return `<tspan class="cm-swatch">\uf0c8</tspan> ${d.layer}: ${value}`;
	}

	setValue(selection) {
		selection.exit().remove();
		let enter = selection.enter().append('tspan').attr('dy', '1.2em').attr('x', 0);
		enter.merge(selection).attr('class', this.layerClass).html(this.layerText);
	}

	setContent({data}) {
		if (!data) {
			this.clearContent();
			return false;
		}

		this.content.selectAll('tspan.cm-key').data([data]).call(this.setKey);

		// Set values and swatches
		let legendData = [];
		for (let l of this.layers) {
			if (_.has(data, l)) {
				legendData.push({layer: l, value: _.get(data, l)});
			}
		}
		this.content.selectAll('tspan.cm-value').data(legendData).call(this.setValue);
		return this;
	}
}

function layeredMixin(superclass) {
	return class extends superclass {
		constructor(options) {
			super(Object.assign({layers: []}, options));
			_.bindAll(this, 'getTotal', 'getMax');
		}

		get allLayers() {
			var options = this.options;
			return options.allLayers || options.layers || [];
		}

		get layers() {
			return this.options.layers || [];
		}

		getTotal(d, i) {
			let total = 0;
			for (let layer of this.allLayers) {
				total += this.getOrCall(layer, d, i) || 0;
			}
			return total;
		}

		getMax(d, i) {
			let max = 0;
			for (let layer of this.allLayers) {
				max = Math.max(max, this.getOrCall(layer, d, i) || 0);
			}
			return max;
		}

		calculateYDomain() {
			return [0, _(this.data).map(this.getTotal).max()];
		}

		layerIndex(layer) {
			return this.allLayers.indexOf(layer);
		}

		layerColourIndex(layer, options) {
			return (this.layerIndex(layer, options) % 15) + 1;
		}

		initLegend() {
			let {innerWidth: width, innerHeight: height} = this.options;
			return new LayeredLegend({width: width, height: height, layers: this.allLayers, key: this.getX});
		}
	};
}
mix.MIXINS.layered = layeredMixin;

module.exports = {
	LayeredChart: mix(BasicChart, layeredMixin),
	LayeredLegend: LayeredLegend,
	layeredMixin: layeredMixin
};